export default {
    state: {
        CUX_PRINT_FORMWORK: [],
        INT_TIME_ZONE: [],
        CUX_INT_QMS_ADDRESS: [],
        INT_NEW_SWITCH: [],
        isNewVersion: true,
    },
    getters: {
        isNewVersion: state => state.isNewVersion,
    },
    mutations: {
        SET_CUX_PRINT_FORMWORK: (state, CUX_PRINT_FORMWORK) => {
            state.CUX_PRINT_FORMWORK = CUX_PRINT_FORMWORK;
        },
        SET_INT_TIME_ZONE: (state, INT_TIME_ZONE) => {
            state.INT_TIME_ZONE = INT_TIME_ZONE;
        },
        SET_CUX_INT_QMS_ADDRESS: (state, CUX_INT_QMS_ADDRESS) => {
            state.CUX_INT_QMS_ADDRESS = CUX_INT_QMS_ADDRESS;
        },
        SET_NEW_SWITCH: (state, INT_NEW_SWITCH) => {
            state.INT_NEW_SWITCH = INT_NEW_SWITCH;
        },
        SET_NEW_VERSION: (state, val) => {
            state.isNewVersion = val;
        },
    },
};
